<template>
  <SettingsPagePanel>
    <TeamManagementForm
      :team="team"
      :is-loading="isLoading"
      :is-submitting="isSubmitting"
      :is-edit-page="true"
      @updateTeam="updateTeam"
    />
  </SettingsPagePanel>
</template>

<script setup lang="ts">
import SettingsPagePanel from '@/pages/SettingsPage/SettingsPagePanel.vue'
import TeamManagementForm from '@/components/organisms/TeamManagementForm/TeamManagementForm.vue'
import { type Team, useTeamDetail } from './composables/useTeamDetail'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute('teamManagementSettingDetail')
const teamGUID = route.params.teamManagementSettingId

const router = useRouter()
const updateTeam = async (team: Team) => {
  handleUpdateTeam(team).then(() => {
    // eslint-disable-next-line fp/no-mutating-methods
    router.push({ name: 'teamManagementSetting' })
  })
}

const { team, isLoading, isSubmitting, handleUpdateTeam } =
  useTeamDetail(teamGUID)
</script>
